export function formatRuPhoneE164(value: string) {
  if (!value) return "";

  // Оставляем только цифры
  const digits = String(value).replace(/\D/g, "");

  // Поддержка: "+7..." и "8..." и "7..."
  let d = digits;
  if (d.startsWith("8") && d.length === 11) d = "7" + d.slice(1);

  if (d.startsWith("7") && d.length === 11) {
    const a = d.slice(1, 4);
    const b = d.slice(4, 7);
    const c = d.slice(7, 9);
    const e = d.slice(9, 11);
    return `+7 (${a}) ${b}-${c}-${e}`;
  }
  
  return value;
}